import { common, PROD_ADOBE_ENV, PROD_MEDALLIA_ENV, prodNodeEnv } from './environment.shared';

export const environment = {
  ...common,
  ...PROD_MEDALLIA_ENV,
  ...PROD_ADOBE_ENV,
  advisorsBaseUrl: 'https://advisors.vanguard.com',
  production: true,
  deployment: 'prod',
  ...prodNodeEnv,
  gatekeeperRegion: 'PROD',
  user_status_endpoint: 'https://advisors.vanguard.com/fasdigital/user-status',
  // TODO: prod not yet deployed (see BXR_INTEGRATION_HANDOFF.md)
  betrCalculateUrl: '',
  taxRatesUrl: '',
};
